import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
export function Offer() {
  return <Section id="offer" className="max-w-4xl text-center" data-id="element-186">
      <div className="p-8 md:p-16 border border-border bg-dark relative overflow-hidden" data-id="element-187">
        <div className="absolute top-0 left-0 w-full h-1 bg-blood" data-id="element-188"></div>

        <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 border border-blood/40 bg-blood/10" data-id="element-189">
          <span className="w-2 h-2 bg-blood rounded-full animate-pulse" data-id="element-190"></span>
          <span className="text-blood font-sans text-xs font-bold tracking-widest uppercase" data-id="element-191">
            Oferta de Lanzamiento — Por Tiempo Limitado
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-foreground" data-id="element-192">
          Recupera el mando de tu vida
        </h2>

        <p className="text-lg md:text-xl text-foreground/70 font-sans font-light leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-193">
          Por una fracción de lo que te cuesta una sola oportunidad perdida por
          no saber negociar tu valor. Consigue El Código de la Sombra por un
          pago único.
        </p>

        <div className="mb-10" data-id="element-194">
          <span className="text-foreground/50 font-sans text-sm uppercase tracking-widest block mb-3" data-id="element-195">
            Precio
          </span>
          <div className="flex items-baseline justify-center gap-4 flex-wrap" data-id="element-196">
            <span className="text-2xl md:text-3xl font-serif text-foreground/40 line-through decoration-blood/70 decoration-2" data-id="element-197">
              $27 USD
            </span>
            <span className="text-5xl md:text-7xl font-serif font-bold text-foreground" data-id="element-198">
              $14.99
            </span>
            <span className="text-xl md:text-2xl font-sans text-foreground/60" data-id="element-199">
              USD
            </span>
          </div>
          <p className="text-blood font-sans text-sm font-semibold tracking-wide uppercase mt-4" data-id="element-200">
            Ahorras $12 — 44% de descuento
          </p>
        </div>

        <div className="max-w-md mx-auto flex flex-col gap-4" data-id="element-201">
          <Button fullWidth href="https://pay.hotmart.com/G105750225G?off=exnypaed" data-id="element-202">
            Haz clic aquí para descargar el código de la sombra
          </Button>
          <p className="text-xs text-foreground/50 font-sans" data-id="element-203">
            Acceso instantáneo. Formato PDF compatible con todos los
            dispositivos.
          </p>
        </div>
      </div>
    </Section>;
}